// extracted by mini-css-extract-plugin
export var container = "ourTeamTabs-module--container--47566";
export var grid = "ourTeamTabs-module--grid--b9574";